import React from 'react';
import { FaFootballBall } from 'react-icons/fa';
import websitelogo from "../../Assets/projectlogo.jpg";
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader">
        <img src={websitelogo} alt="Logo" className='websitelogo' />
        {/* <FaFootballBall className="football-icon" /> */}
      </div>
      {/* <p>Loading Football Stats...</p> */}
    </div>
  );
};
export default Loader;